import React from 'react';
import load from '@loadable/component';

// TODO: Update this once React.suspense and React.lazy have SSR support!
// https://reactjs.org/docs/code-splitting.html#reactlazy

/**
 * A simple method to wrap loadable-component to use a consistent fallback.
 *
 * @param   {func} path  The dynamic import of the path to lazy load.
 * @returns {component}  The wrapped component.
 *
 * example: const App = loadable(() => import('./App.js'));
 */
const loadable = (path) => load(path);

export default loadable;
